/**
 * Единая конфигурация валют приложения
 *
 * Используется во всех фичах, где нужен список/выбор валют:
 * create-wishlist-item, change-currency, manage-secret-santa и др.
 */

import type { Currency } from '@/stores';

/** Описание валюты для UI-списков */
export interface CurrencyOption {
  /** ISO 4217 код */
  id: Currency;
  /** Символ валюты для отображения */
  symbol: string;
  /** i18n ключ для локализованного названия */
  labelKey: string;
}

export const CURRENCY_OPTIONS: CurrencyOption[] = [
  // Топ-3 мировые валюты
  { id: 'USD', symbol: '$', labelKey: 'common:currencies.USD' },
  { id: 'EUR', symbol: '€', labelKey: 'common:currencies.EUR' },
  { id: 'GBP', symbol: '£', labelKey: 'common:currencies.GBP' },
  // Остальные по алфавиту ISO-кода
  { id: 'AUD', symbol: 'A$', labelKey: 'common:currencies.AUD' },
  { id: 'BRL', symbol: 'R$', labelKey: 'common:currencies.BRL' },
  { id: 'CAD', symbol: 'C$', labelKey: 'common:currencies.CAD' },
  { id: 'CHF', symbol: 'CHF', labelKey: 'common:currencies.CHF' },
  { id: 'CNY', symbol: '¥', labelKey: 'common:currencies.CNY' },
  { id: 'CZK', symbol: 'Kč', labelKey: 'common:currencies.CZK' },
  { id: 'DKK', symbol: 'kr', labelKey: 'common:currencies.DKK' },
  { id: 'HKD', symbol: 'HK$', labelKey: 'common:currencies.HKD' },
  { id: 'HUF', symbol: 'Ft', labelKey: 'common:currencies.HUF' },
  { id: 'INR', symbol: '₹', labelKey: 'common:currencies.INR' },
  { id: 'JPY', symbol: '¥', labelKey: 'common:currencies.JPY' },
  { id: 'KRW', symbol: '₩', labelKey: 'common:currencies.KRW' },
  { id: 'KZT', symbol: '₸', labelKey: 'common:currencies.KZT' },
  { id: 'MXN', symbol: 'MX$', labelKey: 'common:currencies.MXN' },
  { id: 'NOK', symbol: 'kr', labelKey: 'common:currencies.NOK' },
  { id: 'NZD', symbol: 'NZ$', labelKey: 'common:currencies.NZD' },
  { id: 'PLN', symbol: 'zł', labelKey: 'common:currencies.PLN' },
  { id: 'RON', symbol: 'lei', labelKey: 'common:currencies.RON' },
  { id: 'RUB', symbol: '₽', labelKey: 'common:currencies.RUB' },
  { id: 'SEK', symbol: 'kr', labelKey: 'common:currencies.SEK' },
  { id: 'SGD', symbol: 'S$', labelKey: 'common:currencies.SGD' },
  { id: 'THB', symbol: '฿', labelKey: 'common:currencies.THB' },
  { id: 'TRY', symbol: '₺', labelKey: 'common:currencies.TRY' },
  { id: 'UAH', symbol: '₴', labelKey: 'common:currencies.UAH' },
  { id: 'ZAR', symbol: 'R', labelKey: 'common:currencies.ZAR' },
];

/** Код валюты по умолчанию для формы добавления товара */
export const DEFAULT_CURRENCY = 'USD';

/** Код валюты по умолчанию (ISO 4217) — fallback при отсутствии валюты в данных из БД */
export const DEFAULT_CURRENCY_CODE = 'RUB';

/** Set допустимых кодов валют — для валидации данных от парсера */
export const SUPPORTED_CURRENCY_IDS = new Set(CURRENCY_OPTIONS.map((c) => c.id));